import { initGraphQLTada } from "gql.tada";

import type { introspection } from "@/generated/graphql-tada-env.d.ts";

export const graphql = initGraphQLTada<{
  introspection: introspection;
  scalars: {
    Date: string;
    DateTime: string;
    Decimal: string;
    JSON: { [key: string]: any };
    timestamptz: string;
    numeric: number;
    ID: string;
    Upload: Readonly<File | FileList>;
  };
}>();

export type { FragmentOf, ResultOf, VariablesOf } from "gql.tada";
export { readFragment } from "gql.tada";

export namespace typename {
  export const CrmDonor = "CrmDonorType";
  export const DonorList = "GQLDonorList";
  export const Portfolio = "PortfolioType";
  export const RecAuto = "RecAutoType";
  export const RecManual = "RecManualType";
}
